module.exports = __webpack_public_path__ + "img/horizontal_4_4_8023.edb2ceb5.png";